/* eslint-disable dot-notation */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import API from '../../Services/API';

export const LoadGroupRequest = createAsyncThunk('groups/load', async () => {
  try {
    const res = await API().get('/evp-groups');
    return res.data;
  } catch (error) {
    console.log('LoadGroupRequest error ', error);
  }
});

export const LoadUsersRequest = createAsyncThunk('users/load', async (data, { dispatch }) => {
  try {
    if (data.groupName === 'all') {
      const res = await API().get('/evp-users', { params: data.params });
      if (res.data.pagination_token !== null) {
        dispatch(
          LoadUsersRequest({
            groupName: data.groupName,
            params: { limit: 50, pagination_token: res.data.pagination_token }
          })
        );
      }
      return { ...res.data, groupName: data.groupName };
    } else {
      const res = await API().get(`/evp-groups/${data.groupName}/users`, { params: data.params });
      if (res.data.pagination_token !== null) {
        dispatch(
          LoadUsersRequest({
            groupName: data.groupName,
            params: { limit: 50, pagination_token: res.data.pagination_token }
          })
        );
      }
      return { ...res.data, groupName: data.groupName };
    }
  } catch (error) {
    console.log('LoadUsersRequest error ', error);
  }
});

export const LoadSingleUserRequest = createAsyncThunk('users/loadSingle', async (email) => {
  try {
    const res = await API().get(`/evp-users/${email}`);
    return res.data;
  } catch (error) {
    console.log('LoadSingleUserRequest error ', error);
    return false;
  }
});

const initialState = {
  userLoading: false,
  groupName: '',
  targetUser: {},
  list: [],
  groups: []
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    SetTargetUser: (state, { payload }) => {
      if (Object.keys(payload).length > 0) {
        state.targetUser = payload;
      }
    },
    SetGroupName: (state, { payload }) => {
      state.groupName = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(LoadUsersRequest.pending, (state) => {
      state.userLoading = true;
      state.list = [];
    });
    builder.addCase(LoadUsersRequest.fulfilled, (state, { payload }) => {
      if (payload !== undefined) {
        if (payload.groupName === state.groupName) {
          state.list = _.uniqBy([...state.list, ...payload.users], 'username');
        } else {
          state.list = payload.users;
        }
        state.userLoading = false;
      } else {
        state.list = [];
        state.userLoading = false;
      }
    });
    builder.addCase(LoadGroupRequest.fulfilled, (state, { payload }) => {
      state.groups = payload.users;
    });
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default userSlice.reducer;
export const userActions = userSlice.actions;
